import { getRequest } from "../../Apis/apiWrapper";
import {
  authEndpoints,
  CampaignSettingsEndpoints,
  icpEndpoints,
} from "../constants/httpConstants";

/**
 * Calls the same 4 APIs that SetupWizardProvider uses to check which of the
 * 4 account-setup steps (mailbox, signature, ICP, knowledge-base) are done.
 * Returns { mailbox, signature, icp, kb } — each a boolean.
 *
 * Used by both LearningCenter and GuidedTourBanner so the composite progress
 * formula (num + doneCount) / (den + 4) is calculated consistently.
 */
export const fetchSetupStatuses = async () => {
  const checkMailbox = async () => {
    try {
      const res = await getRequest(null, authEndpoints.getApiKeyDetails);
      const inboxes = res?.data?.data?.inboxes || {};
      const hasInbox = Object.values(inboxes).some((arr) => Array.isArray(arr) && arr.length > 0);
      const hasOtherEsp =
        Array.isArray(res?.data?.data?.other_api_details) &&
        res.data.data.other_api_details.length > 0;
      return hasInbox || hasOtherEsp;
    } catch { return false; }
  };

  const checkSignature = async () => {
    try {
      const res = await getRequest(null, CampaignSettingsEndpoints.signatureList);
      const data = res?.data?.data || {};
      return Object.values(data).some(
        (bucket) =>
          Array.isArray(bucket?.signatures) &&
          bucket.signatures.some((s) => s?.is_default === true)
      );
    } catch { return false; }
  };

  const checkICP = async () => {
    try {
      const res = await getRequest(null, `${icpEndpoints.getAllPersonas}?_t=${Date.now()}`);
      return Array.isArray(res?.data?.data) && res.data.data.length > 0;
    } catch { return false; }
  };

  const checkKB = async () => {
    try {
      const res = await getRequest(null, authEndpoints.getCompanySummary);
      return !!res?.data?.data?.summary;
    } catch { return false; }
  };

  const [mailbox, signature, icp, kb] = await Promise.all([
    checkMailbox(),
    checkSignature(),
    checkICP(),
    checkKB(),
  ]);

  return { mailbox, signature, icp, kb };
};
